import { styled } from '@styledComponents';
import { Text } from '@components/typography';
import { themeSpace } from '@utils/styledTheme.util';

export const SelectWrapper = styled.div`
  border-radius: 20px;
  display: inline-flex;
  margin-top: ${themeSpace(9)};
  width: 208px;
`;

export const StyledArrowSvg = styled.svg<{ isOpen?: boolean }>`
  float: right;
  ${({ isOpen }) =>
    isOpen
      ? {
          transform: 'rotate(180deg)',
        }
      : null}
`;

export const StyledDropdown = styled.div<{ isOpen?: boolean }>`
  cursor: pointer;
  padding: ${themeSpace(3)} ${themeSpace(5)};
  text-align: center;
  border-radius: 20px;
  background: rgba(249, 245, 240, 0.5);
  width: 100%;
`;

export const SelecteStyledText = styled(Text)`
  top: 0px;
  position: relative;
  display: inline-block;
`;

export const DropdownContainer = styled.ul<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  z-index: 5;
  position: absolute;
  width: 208px;
  padding: ${themeSpace(4)} ${themeSpace(6)};
  margin-top: ${themeSpace(9)};
  background: white;
  box-shadow: 0px 7px 27px rgba(44, 41, 37, 0.06), 0px 4px 16px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
`;

export const DropdownContainerItem = styled.li`
  padding-left: 0;
  position: relative;
  height: 26px;
  padding: 0px;
  margin: ${themeSpace(5)} 0px;
`;

export const StyledLabel = styled.label`
  display: block;
  position: relative;
  padding-left: ${themeSpace(7)};
  margin-bottom: ${themeSpace(4)};
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
`;

export const StyledText = styled(Text)<{ left?: string }>`
  position: absolute;
  top: 0;
  left: ${(props) => props.left + 'px' || '0px'};
  font-size: 13px;
  line-height: 17px;
  padding: ${themeSpace(1)};
  width: 100%;
`;
